import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { TGetClientOrderCargoesRes } from 'api/swagger';
import { CLIENT_ORDER_CARGOES_GET_MANY } from '../query-keys';

export const useGetClientOrderCargoes = (orderId: number) => {
  return useQuery<TGetClientOrderCargoesRes[]>({
    queryKey: [CLIENT_ORDER_CARGOES_GET_MANY, orderId],
    queryFn: async () => {
      const { data } = await http.get<TGetClientOrderCargoesRes[]>(`/client-office/v1/orders/${orderId}/cargoes`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
